export default __webpack_public_path__ + "static/media/park_linowy_regulamin_zal_2_3.fbc795f7.doc";